import styled from 'styled-components';

export const Fallback = styled.div`
  text-align: center;
`;
